// import { Navigate, Outlet } from "react-router-dom";

// const ProtectedRoute = () => {
//   const token = localStorage.getItem("adminToken");

//   return token ? <Outlet /> : <Navigate to="/admin/login" />;
// };

// export default ProtectedRoute;
import { Navigate, Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../config/config";
import SiteCurrencyBootstrap from "./SiteCurrencyBootstrap";

const ProtectedRoute = () => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem("adminToken");

      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(`${API_URL}/me`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data.success && response.data.user) {
          setIsAuthenticated(true);
          // Store user info in localStorage for role-based access
          localStorage.setItem("adminUser", JSON.stringify(response.data.user));
        } else {
          localStorage.removeItem("adminToken");
          localStorage.removeItem("adminUser");
        }
      } catch (error) {
        // If token is expired or invalid, remove it
        // console.error("Auth check error:", error.response?.data || error.message);
        localStorage.removeItem("adminToken");
        localStorage.removeItem("adminUser");
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (loading) {
    return <div style={{ textAlign: "center", marginTop: "30vh" }}>🔐 Checking session…</div>;
  }

  return isAuthenticated ? (
    <>
      <SiteCurrencyBootstrap />
      <Outlet />
    </>
  ) : (
    <Navigate to="/admin/login" replace />
  );
};

export default ProtectedRoute;



